module.exports = __webpack_public_path__ + "img/4.7872aff8.jpg";